import * as React from "react";

// SVG for Terraform logo (brand color)
const TerraformIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M38.06 26.151v11.473L48 31.891V20.406l-9.94 5.745z"
        fill="#4040B2"
      ></path>
      <path
        d="m27.03 20.406 9.94 5.745v11.473l-9.94-5.74V20.407zM16 14v11.479l9.94 5.74v-11.48L16 14zm11.03 30.624 9.94 5.74v-11.48l-9.94-5.739v11.48z"
        fill="#5C4EE5"
      ></path>
    </g>
  </svg>
);

export default TerraformIcon;
